import { JWT_DURATION } from '@/config'
import jwt from 'jsonwebtoken'

export async function encrypt(payload: any) {
  return jwt.sign(payload, process.env.JWT_SECRET as string, {
    algorithm: 'HS256',
    expiresIn: JWT_DURATION,
  })
}

export async function decrypt(token: string) {
  return jwt.verify(token, process.env.JWT_SECRET as string)
}
